<template>
    <div class="banner-root">
        <div class="banner-content">
            <div class="banner-left">
                <h1 class="banner-title">
                    For Every Item,<br class="pc-only" />
                    The Right Owner.
                </h1>
                <div class="banner-sub">
                    <div class="banner-desc">Buyers use more & Save more ,<br />Sellers sell more & Value more!</div>
                    <div class="banner-gray-text">On XigFor, every transaction is recorded<br />toward your effective platform benefits.</div>
                </div>
                <div class="cta-row">
                    <router-link to="/content/smartrewards-terms" class="cta-btn" aria-label="SmartRewards">
                        <img src="@/assets/rocket.png" class="cta-icon-img" alt="SmartRewards" />
                        <span>SmartRewards</span>
                        <img src="@/assets/arrow_right.png" class="cta-arrow-img" alt="Go" />
                    </router-link>
                </div>
                <div class="banner-apps">
                    <div class="use-app-row">
                        <img src="@/assets/useapp.png" class="use-app-icon" alt="Use APP" />
                        <span class="use-app">Use APP</span>
                    </div>
                    <p class="app-desc">In-app purchases are used only for digital platform services such as promotion and visibility tools.</p>
                    <div class="app-btns">
                        <img src="@/assets/googleplay.png" alt="Google Play" class="app-btn" />
                        <img src="@/assets/appstore.png" alt="App Store" class="app-btn" />
                        <img src="@/assets/android.png" alt="Universal APK" class="app-btn" />
                    </div>
                </div>
            </div>
            <div class="banner-right">
                <img src="@/assets/home-2.png" alt="Phone" class="phone-img" />
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Banner'
}
</script>

<style scoped>
.banner-root {
    width: 100%;
    /* background: #fff; */
    padding: 23px 0 0 0;
    overflow-x: hidden;
}
.banner-content {
    max-width: 1220px;
    margin: 0 auto;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    min-height: 440px;
    /* padding: 0 20px; */
}
.banner-left {
    flex: 1;
    /* padding-left: 32px; */
}
.banner-title {
    font-family: 'Inter', sans-serif;
    font-size: 70px;
    font-weight: 700;
    /* font-style: italic; */
    color: #191a15;
    margin-bottom: 18px;
    line-height: 99px;
    /* white-space: nowrap; */
}
.banner-desc {
    font-family: 'Inter', sans-serif;
    font-size: 36px;
    color: #6c6c78;
    font-weight: 500;
    margin-bottom: 17px;
    line-height: 54px;
}
.banner-gray-text {
    font-family: 'Poppins', sans-serif;
    font-size: 24px;
    color: #9b9ca5;
    font-weight: 300;
    margin-bottom: 8px;
    line-height: 37px;
}
.banner-apps {
    margin-top: 24px;
}
.use-app-row {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 8px;
}
.use-app-icon {
    height: 28px;
    width: auto;
    opacity: 0.75;
}
.use-app {
    color: rgba(119, 119, 119, 1);
    font-size: 18px;
    font-family: 'Sansita', Arial, sans-serif;
    font-weight: 700;
}
.app-btns {
    display: flex;
    flex-direction: row;
    gap: 16px;
    margin-top: 28px;
}
.app-btn {
    height: 48px;
    width: auto;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}
.banner-right {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    position: relative;
    min-width: 420px;
}
.phone-bg {
    position: relative;
    width: 340px;
    height: 480px;
    display: flex;
    align-items: center;
    justify-content: center;
}
.phone-img {
    position: relative;
    z-index: 2;
    width: 594px;
    height: auto;
}
.red-circle {
    position: absolute;
    left: 50%;
    top: 54%;
    transform: translate(-50%, -50%);
    width: 270px;
    height: 270px;
    border-radius: 50%;
    background: radial-gradient(circle at 60% 40%, #ff9966 0%, #ff5e62 100%);
    z-index: 1;
    filter: blur(0.5px);
}
.red-x {
    position: absolute;
    left: 30px;
    bottom: 60px;
    color: #ff5e62;
    font-size: 2.2rem;
    font-weight: bold;
    z-index: 3;
    font-family: 'Arial Black', Arial, sans-serif;
    opacity: 0.85;
}
.red-dot {
    position: absolute;
    right: 32px;
    top: 60px;
    width: 18px;
    height: 18px;
    background: #ff5e62;
    border-radius: 50%;
    z-index: 3;
    opacity: 0.85;
}
.cta-row {
    margin-top: 12px;
}
.cta-btn {
    display: inline-flex;
    align-items: center;
    gap: 10px;
    padding: 12px 22px;
    background: rgba(255, 87, 51, 1);
    color: #fff;
    border-radius: 12px;
    text-decoration: none;
    font-weight: 400;
}
.cta-icon {
    font-size: 1.1rem;
}
.cta-arrow {
    margin-left: 2px;
    font-size: 1.2rem;
}
/* image icons */
.cta-icon-img {
    height: 18px;
    width: auto;
    vertical-align: middle;
}
.cta-arrow-img {
    height: 16px;
    width: auto;
    margin-left: 6px;
    vertical-align: middle;
}
.app-desc {
    font-size: 14px;
    font-weight: 300;
    color: rgba(108, 108, 120, 1);
    margin-bottom: 8px;
    line-height: 1.6;
}
@media (max-width: 900px) {
    .banner-content {
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        min-height: unset;
        padding: 0 12px;
        width: 100%;
        padding-left: 24px;
    }
    .banner-left,
    .banner-right {
        padding: 0;
        min-width: unset;
    }
    .banner-left {
        width: 58%;
    }
    .banner-right {
        width: 42%;
    }
    .banner-title {
        font-family: 'Sansita', Arial, sans-serif;
        font-weight: 700;
        font-size: 14px;
        line-height: 31px;
        margin-bottom: 2px;
        text-align: left;
        width: 170%; /* Overflowing right column to fake full width */
        position: relative;
        z-index: 5;
        color: #393944;
    }
    .banner-desc {
        font-family: 'Poppins', Arial, sans-serif;
        font-size: 11px;
        font-weight: 500;
        line-height: 19px;
        margin-bottom: 2px;
        color: #6c6c78;
    }
    .banner-gray-text {
        font-family: 'Poppins', Arial, sans-serif;
        font-size: 8px;
        font-weight: 400;
        line-height: 19px;
        margin-bottom: 0;
        color: #9b9ca5;
    }
    .cta-btn {
        padding: 6px 12px;
        border-radius: 4px;

        font-size: 10px;
    }
    .cta-icon-img {
        height: 6px;
    }
    .cta-arrow-img {
        height: 6px;
    }
    .app-desc {
        font-size: 7px;
        line-height: 1.4;
        margin-bottom: 10px;
    }
    .banner-apps {
        margin-top: 12px;
    }
    .cta-row {
        margin-top: 6px;
    }
    .banner-right {
        margin-top: 0;
        display: flex;
        justify-content: flex-end;
    }
    .phone-img {
        width: 160px;
        max-width: 180px;
        margin-bottom: 50px;
    }
    .app-btns {
        gap: 8px;
        display: flex;
        margin-top: 12px;
    }
    .app-btn {
        height: 28px;
    }
    .app-btn-android {
        height: 28px;
        margin-top: 4px;
    }
    .use-app {
        font-size: 0.8rem;
    }
    .use-app-icon {
        height: 18px;
    }
    .pc-only {
        display: none !important;
    }
}
</style>
